let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Zpch")).then(() => parcelRequire('db8Lu'));